/**
 * Il codice di una categoria in forma leggibile: «VETRATE_PANORAMICHE» → «Vetrate panoramiche». Solo per l'elenco della
 * console: il codice resta la chiave, mai tradotta.
 */
export function nomeProdotto(codice: string): string {
  const parole = codice.toLowerCase().replace(/_/g, ' ');
  return parole.charAt(0).toUpperCase() + parole.slice(1);
}
